import { createRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { MessagePage } from '$/pages/MessagePage';
import { RootRoute } from '$/routes/RootRoute';

const Component = () => {
  const { t } = useTranslation();

  return (
    <MessagePage
      headerText={t('dashboard.authentication.registration.landingPageHeader')}
      icon='leaderboard'
      descriptionText={t(
        'dashboard.authentication.registration.landingPageDescription',
      )}
      buttonText={t('general.backHomeShort')}
    />
  );
};

export const RegistrationSuccessfulPage = createRoute({
  getParentRoute: () => RootRoute,
  path: '/registration-successful',
  component: Component,
});
